import React, { useState } from "react";
import GalleryForm from "../../components/gallery/GalleryForm";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { GalleryServices } from "../../services/admin/GalleryServices";
import { useNotification } from "../../context/NotificationContext";

export default function AddGalleryItemPage() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);

    const handlePublish = async (data) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("media_type", data.type); // backend uses 'media_type', form uses 'type' for UI state
            if (data.youtube_link && data.type === "video") {
                formData.append("youtube_link", data.youtube_link);
            }
            if (data.file) {
                formData.append("file", data.file);
            }
            formData.append("downloadable", data.downloadable);

            const result = await GalleryServices.createItem(formData);
            if (result.status === "success") {
                showNotification({
                    type: "success",
                    title: "Success",
                    message: "Media published successfully!"
                });
                navigate("/admin/gallery");
            }
        } catch (error) {
            console.error("Upload failed", error);
            showNotification({
                type: "failed",
                title: "Error",
                message: error.response?.data?.message || "Failed to publish media."
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="p-6 lg:p-10 max-w-5xl mx-auto">
                {/* Navigation Header */}
                <button
                    onClick={() => navigate("/admin/gallery")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO GALLERY
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Upload New Media
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Add a new captured moment or performance to your public gallery.
                    </p>
                </div>

                {/* Form */}
                <GalleryForm onSubmit={handlePublish} />
                {loading && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded-xl shadow-xl flex items-center gap-4">
                            <div className="w-6 h-6 border-2 border-jazz-brown border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-sm font-bold">Uploading...</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
